import { Component, OnInit } from '@angular/core';
import {
  DocumentsGridComponent
} from "@pages/documents/components/documents-page/components/documents-grid/documents-grid.component";
import { CommonPageComponent } from "@shared/components/commons/common-page/common-page.component";
import { IPartialHeaderData } from "@shared/services/header.service";

@Component({
  selector: 'app-documents',
  standalone: true,
  templateUrl: 'documents-page.component.html',
  styleUrl: 'documents-page.component.scss',
  imports: [DocumentsGridComponent],
})
export class DocumentsPageComponent extends CommonPageComponent implements OnInit {
  override readonly headerData: IPartialHeaderData = {
    title: 'Documents',
    iconClass: 'ic-documents-20'
  };
}

